module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Black_MockedUp.b1b8fec8.jpg";